import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Login from '../pages/Login';
import Foods from '../pages/Foods';
import Drinks from '../pages/Drinks';
import FoodsDetails from '../pages/FoodsDetails';
import DrinksDetails from '../pages/DrinksDetails';
import FoodsProgress from '../pages/FoodsProgress';
import DrinksProgress from '../pages/DrinksProgress';
import Explore from '../pages/Explore';
import ExploreFoods from '../pages/ExploreFoods';
import ExploreDrinks from '../pages/ExploreDrinks';
import ExploreFoodsIngredients from '../pages/ExploreFoodsIngredients';
import ExploreDrinksIngredients from '../pages/ExploreDrinksIngredients';
import ExploreFoodsNationalities from '../pages/ExploreFoodsNationalities';
import Profile from '../pages/Profile';
import DoneRecipes from '../pages/DoneRecipes';
import FavoriteRecipes from '../pages/FavoriteRecipes';
import NotFound from '../pages/NotFound';

function Routes() {
  return (
    <Switch>
      <Route
        exact
        path="/"
        component={ Login }
      />
      <Route
        exact
        path="/foods"
        component={ Foods }
      />
      <Route
        exact
        path="/drinks"
        component={ Drinks }
      />
      <Route
        exact
        path="/foods/:id"
        component={ FoodsDetails }
      />
      <Route
        exact
        path="/drinks/:id"
        component={ DrinksDetails }
      />
      <Route
        path="/foods/:id/in-progress"
        component={ FoodsProgress }
      />
      <Route
        path="/drinks/:id/in-progress"
        component={ DrinksProgress }
      />
      <Route
        exact
        path="/explore"
        component={ Explore }
      />
      <Route
        exact
        path="/explore/foods"
        component={ ExploreFoods }
      />
      <Route
        exact
        path="/explore/drinks"
        component={ ExploreDrinks }
      />
      <Route
        path="/explore/foods/ingredients"
        component={ ExploreFoodsIngredients }
      />
      <Route
        path="/explore/drinks/ingredients"
        component={ ExploreDrinksIngredients }
      />
      <Route
        path="/explore/foods/nationalities"
        component={ ExploreFoodsNationalities }
      />
      <Route
        path="/profile"
        component={ Profile }
      />
      <Route
        path="/done-recipes"
        component={ DoneRecipes }
      />
      <Route
        path="/favorite-recipes"
        component={ FavoriteRecipes }
      />
      <Route
        path="*"
        component={ NotFound }
      />
    </Switch>
  );
}

export default Routes;
